export const uuidReg = new RegExp(
  '^[cm]{2}-[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$',
  'i'
)

export const numberReg = new RegExp('[0-9]')

export const lowerCaseReg = new RegExp('[a-z]')

export const upperCaseReg = new RegExp('[A-Z]')

export const specialCharReg = new RegExp('[-!@#$%^&*_-]')

export const deviceIDReg = new RegExp('^[a-zA-Z0-9]{26}$')

export const deviceIMEIReg = new RegExp('^[0-9]{15}$')
export const deviceSerialNoReg = new RegExp('^[a-zA-Z0-9]{15}$')
export const deviceSmartmeterIDReg = new RegExp('^[a-zA-Z0-9]{7}$')
export const deviceDIDReg = new RegExp('^[a-zA-Z0-9]{20}$')
